import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { PrintableLayout } from '../../components/layout/PrintableLayout';
import { LoadingOverlay } from '../../components/LoadingOverlay';
import { gameConfigStore, useGameConfigSelector } from '../../store/GameConfigStore';
import { useQuestionSetQuestions } from '../../util/GameConfigUtils';
import { muiStyleSheet } from '../../util/Styles';

export const AnswersScreen: FunctionComponent = () => {
	const questionSet = useGameConfigSelector(gameConfigStore.selectors.questionSet);
	const questions = useQuestionSetQuestions(questionSet);

	return <PrintableLayout title='Answer Sheet'>
		<LoadingOverlay loading={questions === undefined} label='Loading questions' />

		{(!questions || questions.empty())
			? <Typography>Choose a Question Set to see its questions</Typography>
			: <Stack spacing={4} sx={{ paddingX: 10 }}>
				{questionSet && <Box sx={styles.questionSetInfo}>
					<Typography sx={styles.questionSetName}>{questionSet.name}</Typography>
					{questionSet.description && <Typography sx={styles.questionSetDescription}>{questionSet.description}</Typography>}
					{questionSet.authorName && <Typography sx={styles.questionSetAuthor}>by {questionSet.authorName}</Typography>}
				</Box>}
				{questions.map((question, questionIndex) =>
					<Box key={question.id} sx={styles.questionBox}>
						<Typography sx={styles.bigText}>
							Q{questionIndex + 1}. {question.text}
						</Typography>

						<Stack divider={<Divider sx={styles.divider} />}>
							{question.answers.map((answer, answerIndex) =>
								<Grid columns={6} container spacing={1} key={`answer-${answerIndex}`}>
									<Grid size={1}>
										<Typography align='right' sx={[{ fontWeight: 'bold' }, styles.smallText]}>
											#{answerIndex + 1}
										</Typography>
									</Grid>
									<Grid size={4}>
										<Typography sx={styles.smallText}>
											{answer.text}
										</Typography>
									</Grid>
									<Grid size={1}>
										<Typography sx={[{ fontWeight: 'bold' }, styles.smallText]}>
											{answer.points} pts
										</Typography>
									</Grid>
								</Grid>
							)}
						</Stack>
					</Box >)}
			</Stack >}
	</PrintableLayout >;
};

const styles = muiStyleSheet({
	questionSetInfo: {
		marginBottom: 2,
	},
	questionSetName: {
		fontSize: '1.5rem',
		fontWeight: 'bold',
		'@media print': {
			fontSize: '1.2rem',
		},
	},
	questionSetDescription: {
		fontSize: '1rem',
		fontStyle: 'italic',
	},
	questionSetAuthor: {
		fontSize: '0.9rem',
	},
	questionBox: theme => ({
		pageBreakInside: 'avoid',
		border: `2px solid ${theme.palette.mind.ochre}`,
		padding: 2,
		'@media print': {
			padding: 1.5,
			borderColor: 'black',
		},
	}),
	bigText: {
		fontSize: '1.3rem',
		fontWeight: 'bold',
		marginBottom: 1,
		'@media print': {
			fontSize: '1.1rem',
		},
	},
	smallText: {

	},
	divider: {
		marginX: 6,
		marginY: 0.5,
	},
});